export default function transformSimpleFilterToFilterModelV0(simpleFilter) {
    if (!simpleFilter)
        return {};
    const res = {};
    for (const key in simpleFilter) {
        res[key] = {};
        res[key]['equals'] = simpleFilter[key];
    }
    return res;
}
